import type { Case } from 'types/case'

export const getCaseDetailKeys = (caseDetails: Case) => {
  return Object.keys(caseDetails)
    .filter(filterUnwantedKeys)
    .filter((key) => {
      const value = caseDetails[key as keyof Case]
      return (
        (value !== null &&
          (typeof value === 'string' || Array.isArray(value)) &&
          value.length > 0) ||
        key.includes('date')
      )
    }) as (keyof Case)[]
}

const filterUnwantedKeys = (key: string) => {
  const unwantedKeys = [
    'id',
    'funeral_home_id',
    'created_at',
    'updated_at',
    'editable_case_id',
    'archived',
  ]

  return !unwantedKeys.includes(key)
}
